import onseasonConfig from '../../../config/onseason.yml';

export const ONSEASON_CONFIG = Object.freeze(onseasonConfig);
export const ONSEASON_BRAND = Object.freeze(onseasonConfig.brand);

export const applyOnseasonBranding = text => {
  if (typeof text !== 'string') return text;

  return text
    .replace(/Chatwoot/g, ONSEASON_BRAND.name)
    .replace(/Woot server/gi, 'support service');
};

export default ONSEASON_CONFIG;
